<template>
  <div id="app">
    <div class="chart-container">
      <canvas id="stacked-bar-chart"></canvas>
    </div>
    
  </div>
</template>

<script>
import Chart from 'chart.js';

export default {
    data () {
          return {
            
          }
    },
    props:['chartData', 'options'],
    methods: {
      createChart(chartId, options, chartData) {
          
        let config = {
                type: 'horizontalBar',
                data: chartData,
                options: options
        };

        let ctx = document.getElementById(chartId).getContext("2d");
        new Chart(ctx, config);

      }
    },
    mounted(){
        this.createChart("stacked-bar-chart", this.options, this.chartData)
    }
}

</script>

<style scoped>

.chart-container {
    height:300px;
}

</style>